// Bounded exact-wire multipart preparation. Never base64 an upload or export keys.
// KRE-26: api-admin SIGNED_UPLOAD_ROUTES(src/admin-device/device-multipart.ts)와 1:1.
// [method, pattern, MB(요청 전체), 파일 수 상한]. 목록에 없는 업로드는 서명하지 않고 막는다.
const MB=1024*1024, FRAMING=65536;
const ROUTES=[
  ['POST',/^\/api\/v1\/registry-batch\/admin\/(?:address\/)?upload$/,30,1],
  ['POST',/^\/api\/v1\/watson\/recording\/upload$/,50,1],
  ['POST',/^\/api\/v1\/report-file\/admin\/save(?:\/owner)?$/,50,10],
  ['PATCH',/^\/api\/v1\/report-file\/admin\/update(?:\/owner)?\/[0-9]{1,18}$/,30,1],
  ['PATCH',/^\/api\/v1\/report-file\/admin\/update$/,30,1],
  ['POST',/^\/api\/v1\/subscribe-file\/admin\/save$/,50,10],
  ['PATCH',/^\/api\/v1\/subscribe-file\/admin\/update(?:\/[0-9]{1,18})?$/,30,1],
  ['PATCH',/^\/api\/v1\/subscribe-analyze-file\/update$/,30,1],
  ['POST',/^\/api\/v1\/direct-deal\/admin\/[0-9]{1,18}\/registry-upload$/,30,1],
  ['POST',/^\/api\/v1\/sherlock\/monitoring\/contracts\/[0-9]{1,18}\/register\/parse$/,5,1],
  ['POST',/^\/api\/v1\/typhoon-excel\/raw-data$/,30,1],
];
function uploadRoute(method, pathname) {
  for (const [m,pattern,mb,files] of ROUTES) if (m===method && pattern.test(pathname)) return {cap:mb*MB+FRAMING,files};
  return null;
}
export function rawUploadLimit(method, pathname) { const route=uploadRoute(method,pathname); return route ? route.cap : null; }
export function rawUploadMaxFiles(method, pathname) { const route=uploadRoute(method,pathname); return route ? route.files : null; }
export async function signedMultipart(form, method, path) {
  const route=uploadRoute(method,path.split('?')[0]);
  if (!route || !(form instanceof FormData)) throw new Error('device_upload_route');
  const cap=route.cap;
  const boundary='nzsc_device_'+Array.from(crypto.getRandomValues(new Uint8Array(16)),v=>v.toString(16).padStart(2,'0')).join('');
  const chunks=[];let fields=0,files=0;
  for (const [name,value] of form.entries()) {
    if (!/^[A-Za-z0-9_]{1,64}$/.test(name)) throw new Error('device_upload_field');
    if (typeof value === 'string') {
      if (++fields>16 || new TextEncoder().encode(value).length>65536) throw new Error('device_upload_bound');
      chunks.push(`--${boundary}\r\nContent-Disposition: form-data; name="${name}"\r\n\r\n`,value,'\r\n');
    } else {
      if (++files>route.files || value.name.length>256 || /[\x00-\x1f\x7f]/.test(value.name)) throw new Error('device_upload_bound');
      const filename=value.name.replace(/"/g,'%22');
      const mime=value.type || 'application/octet-stream';
      if (!/^[a-zA-Z0-9.+-]+\/[a-zA-Z0-9.+-]+$/.test(mime)) throw new Error('device_upload_type');
      chunks.push(`--${boundary}\r\nContent-Disposition: form-data; name="${name}"; filename="${filename}"\r\nContent-Type: ${mime}\r\n\r\n`,value,'\r\n');
    }
  }
  if (files<1) throw new Error('device_upload_file');
  chunks.push(`--${boundary}--\r\n`);
  const blob=new Blob(chunks,{type:'multipart/form-data; boundary='+boundary});
  if(blob.size>cap)throw new Error('device_upload_bound');
  // WebCrypto requires one bounded ArrayBuffer. Blob parts still reference the
  // original file; no second serialized body buffer is retained or base64 encoded.
  const body_hash=Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',await blob.arrayBuffer())),v=>v.toString(16).padStart(2,'0')).join('');
  return {blob,body_hash,content_type:blob.type};
}
